import React, { useContext } from "react";
import { Icon } from "../../../../components/Component";
import { FileManagerContext } from "../FileManagerContext";



const Details = ({ file, toggle, toggleShare }) => {
  const { downloadFile } = useContext(FileManagerContext);
  let link = file?.link;
  let parts = link.split("drive/");
  let result = parts[1];
  
  let link2 = result;
  let parts2 = link2.split("/");
  let locationFile1 = parts2[0];
  let locationFile2 = parts2[1];

  // const isPicture = (extension) => {
  //   const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico', 'tiff', 'tif'];
  //   return imageExtensions.includes(extension.toLowerCase());
  // };

  return (
    <React.Fragment>
      <div className="modal-header align-center">
        <div className="nk-file-title">
          <div className="nk-file-icon">{file?.meta?.svg}</div>
          <div className="nk-file-name">
            <div className="nk-file-name-text">
              <span className="title">File Detail</span>
            </div>
          </div>
        </div>
        <a
          href="#close"
          onClick={(ev) => {
            ev.preventDefault();
            toggle();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
      </div>
      <div className="modal-body">
        <div className="nk-file-details">
          <div className="nk-file-details-row">
            <div className="nk-file-details-col">Name</div>
            <div className="nk-file-details-col">{file?.name}</div>
          </div>
          <div className="nk-file-details-row">
            <div className="nk-file-details-col">Type</div>
            <div className="nk-file-details-col">{file?.extension}</div>
          </div>
          <div className="nk-file-details-row">
            <div className="nk-file-details-col">Size</div>
            <div className="nk-file-details-col">{(file?.size/1024).toFixed(2)} KB</div>
          </div>
          <div className="nk-file-details-row">
            <div className="nk-file-details-col">Location</div>
            <div className="nk-file-details-col">
              <ul className="breadcrumb breadcrumb-sm breadcrumb-alt breadcrumb-arrow">
                <li className="breadcrumb-item">{locationFile1}</li>
                <li className="breadcrumb-item">{locationFile2}</li>
              </ul>
            </div>
          </div>
          <div className="nk-file-details-row">
            <div className="nk-file-details-col">Upload At</div>
            <div className="nk-file-details-col">{file?.createdAt}</div>
          </div>
          {/* <div className="nk-file-details-row center">
            <img 
              alt=""
              data-file-id={file.id}
              src={isPicture(file.extension) ? process.env.REACT_APP_S3_URL + file.link : null}
              style={{
                // maxWidth: '400px',
                height: '500px',
                objectFit: 'contain', // or 'contain' depending on your preference
                objectPosition: 'center'
              }}
            />
          </div> */}
        </div>
      </div>
      <div className="modal-footer modal-footer-stretch bg-light">
        <div className="modal-footer-between">
          {/* <div className="g">
            <a href="link" onClick={(ev) => ev.preventDefault()} className="link link-primary">
              View All Activity
            </a>
          </div> */}
          <div className="g">
            <ul className="btn-toolbar g-3">
              {/* <li>
                <a
                  href="#file-share"
                  onClick={(ev) => {
                    ev.preventDefault();
                    toggle();
                    toggleShare();
                  }}
                  className="btn btn-outline-light btn-white"
                >
                  Share
                </a>
              </li> */}
              <li>
                <a
                  href="link"
                  onClick={(ev) => {
                    ev.preventDefault();
                    downloadFile(file);
                  }}
                  className="btn btn-primary file-dl-toast right"
                >
                  Download
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Details;
